export const FEED_ITEM = 'feed-item';
